/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import { useSelector } from 'react-redux';

import type { Twitch } from '@swf/cms';
import Iframe from '@swf/components/Iframe/Iframe';
import { select } from '@swf/core/store';

import styles from './CMSTwitch.scss';

const CMSTwitch: React.FC<Twitch> = ({ channel_name }) => {
  const hostname = useSelector(select.location.getHostname);

  return (
    <div className={styles.videoWrap}>
      <Iframe
        src={`https://player.twitch.tv/?channel=${channel_name}&parent=${hostname}`}
        className={styles.iframe}
      />
    </div>
  );
};

export default CMSTwitch;
